/**
 * site.js: loaded on every public page (header search, sidebar, banner, `<time>` localization,
 * "Show more" toggles, page-view beacon). See CONTRACT.md.
 */
import '../site/search-box';
import '../site/sidebar';
import '../site/banner';
import { whenParsed } from '../lib/dom';
import { localizeTimes } from '../lib/time';
import { trackPageView } from '../site/beacon';
import { enhanceExpandables } from '../site/expandable';

const RELATIVE_TIME_REFRESH_MS = 60_000;

void whenParsed().then(() => {
  localizeTimes(document);
  enhanceExpandables(document);
  setInterval(() => {
    localizeTimes(document);
  }, RELATIVE_TIME_REFRESH_MS);
  trackPageView(document);
});
